<div class="container-fluid">
  <div class="row">
    <!-- FORM  -->
    <div class="col-2">
      <div id="container-form" class="position-relative">
        <form [formGroup]="form">
          <input
            class="form-control"
            type="text"
            id="search"
            name="search"
            [placeholder]="placeholder"
            formControlName="search"
          />
          <span *ngIf="menuOptions.length" class="material-symbols-outlined icon-menu"
                (click)="toggleMenu($event)"
          >
            menu
          </span>
        </form>
      </div>
    </div>

    <!-- Menu Items -->
    <div *ngIf="showMenu" class="container-menu" (click)="toggleMenu($event)">
      <div class="position-relative w-100 h-100">
        <div class="menu"
             [ngStyle]="{
                'top': menuCoords.y + 28 + 'px',
                'left': menuCoords.x + 50 + 'px',
                  transform: 'translate(-100%,0)'
          }"
        >
          <div class="options-menu"
            [ngClass]="{'rounded-top': first, 'rounded-bottom': last}"
            *ngFor="let option of menuOptions; let first = first; let last = last"
            (click)="selectMenuOption(option)"
          >
            <span>{{option.label}} </span>
          </div>

        </div>
      </div>
    </div>

    <!-- SEARCH CONDITION  -->
    <div class="col-auto d-flex align-items-center">
      <div *ngIf="value && this.menuOptions.length">
        <div class="container-selected position-relative">
          <div class="text-sm mx-1">
            <span ><b>{{get_value().label}}</b>: </span> {{get_value().value}}
          </div>
          <div class="mx-1 pointer" (click)="clean_value()">
            <span class="text-sm close-condition">x</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
